import React from 'react'
const Required = ({text}) =>  <span style={{color: 'rgb(255, 148, 148)'}}>*</span>
export default Required;